import axios from 'axios';
import Vue from 'vue'
import store from '@/store'
import router from '../router'
const service = axios.create({
  baseURL: process.env.API_ROOT,
  withCredentials: true,
  timeout: 120000,//请求超时时间
  // headers: {
  //   'Accept': 'application/json'
  // }
})
//添加拦截器
service.interceptors.request.use(config => {
  const isToken = (config.headers || {}).isToken === false
  const token = store.state.user.Authorization
  if (token && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + token// token
  }
  // 请求之前判断token是否存在或者过去，如果过期直接跳转到登陆界面，再次获取token
  // const token = localStorage.getItem('token');
  // token && (config.headers.Authorization = token)//请求带上token
  return config;
}, error => {
  return Promise.reject()
})

//添加响应拦截器
service.interceptors.response.use(response => {
  if (response.config['responseType'] == 'blob') {
    return response
  }
  if (response.status === 200 || response.status === 424) {
    //拦截401
    if( response.data.code && response.data.code == 401){
      Vue.prototype.$message.error('登录过期，请重新登录！');
      setTimeout(()=>{
        store.dispatch('Logout').then(() => {
          router.replace({ path: "/login" });
       })
      },1000);
      Vue.prototype.$message.closeAll();
      return false
    }
    return response.data;
  } else {
    $message.error('登录过期，请重新登录！');
    Promise.reject();
  }
},
  error => {
    const Erroe = error.response
    // console.log(Erroe)
  //拦截403 没有token
    if( Erroe && Erroe.status === 401 || Erroe.status === 424){
      Vue.prototype.$message.error('登录过期，请重新登录！');
      setTimeout(()=>{
        store.dispatch('Logout').then(() => {
          router.replace({ path: "/login" });
       })
      },1000);
      return false
    } else if (Erroe.data && Erroe.data.msg) {
      Vue.prototype.$message.error(Erroe.data.msg)
    } else {
      // Vue.prototype.$message.closeAll()
      Vue.prototype.$message.error(`${Erroe.status} ${Erroe.statusText}` || '网络错误')
    }
    return Promise.reject(error)
    // let { response } = error
    // if (response) {
    //   //=》服务器最起码返回结果
    //   switch (response.status) {
    //     case 401: //=>权限
    //       break;
    //     case 403: //服务器拒绝执行（token过期）
    //       break;
    //     case 501:
    //       break;
    //     default:
    //
    //   }
    // } else {
    //   if (!window.navigator.onLine) {
    //     //断网处理：可以跳转到断网页面
    //     return;
    //   }
    //   return Promise.reject(error)
    // }
  })

export default service;



// WEBPACK FOOTER //
// ./src/util/request.js